import React from "react";
import {Container,Row,  Col,  Card,  CardBody,  Button,  Nav,  NavItem,  NavLink,} from "reactstrap";

import {useNavigate } from "react-router-dom";

const ViewJobPost = () => {
  const jobId = "JD1023"; 
  const navigate = useNavigate();
  return (

  <div className="pt-4" style={{ backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
    <Container fluid className="p-5" style={{ background: "#f8f9fa" }}>
       <Row className="mt-3">
         <Col>
         <p>View Job Postings/ JD1023/ View Post</p>
          <h2 style={{ color: "#222222" }}>View Job Post</h2>
         </Col>                
        </Row>

      {/* Tabs */}
      <Nav tabs className="mb-4">
        <NavItem>
          <NavLink active>Overview</NavLink>
        </NavItem>
        <NavItem>
          <NavLink onClick={() => navigate(`/submitted-candidate/${jobId}`)}>
            Submitted Candidates
          </NavLink>
        </NavItem>
      </Nav>

      {/* Basic Details Section */}
  <Card className="mb-4">
  <CardBody className="p-3 rounded-3" style={{ background: "#F5F6F8" }}>
   <Row>
    <Col md="6">
      <p>Job ID<br /><strong>JD1023</strong></p>
      <p>Job Title<br /><strong>Frontend Developer</strong></p>
      <p>Company Name<br /><strong>Elbert Technologies</strong></p>
      <p>Job Posted On<br /><strong>dd/mm/yyyy</strong></p>
      <p>Department<br /><strong>Engineering</strong></p>
      <p>Pay Type<br /><strong>Full Time, CTC</strong></p>
    </Col>
    <Col md="6">
      <p>Experience Required<br /><strong>3 Yrs</strong></p>
      <p>Number of Openings<br /><strong>3</strong></p>
      <p>Location<br /><strong>Hyderabad</strong></p>
      <p>Job Expiry Date<br /><strong>dd/mm/yyyy</strong></p>
      <p>Work Type<br /><strong>Onsite</strong></p>
      <p>Salary<br /><strong>5 - 10 LPA</strong></p>
    </Col>
  </Row>
 </CardBody>
</Card>
      {/* Job Sections */}
      {[
        { title: "Job Description", content: "We are looking for a passionate Frontend Developer to join our growing team. The ideal candidate will be proficient in modern frontend frameworks and demonstrate an eye for design and performance." },
        { title: "Company Overview", content: "Elbert Technology is a fast-growing IT solutions company that specializes in building intelligent software systems for enterprise, mid-sized, and startup businesses across the globe. With a passion for solving real-world problems through scalable tech, we deliver custom web, mobile, and cloud-based applications that drive innovation and efficiency. We pride ourselves on being more than just a technology vendor – we’re a trusted digital partner for our clients." },
        { title: "What We Do?", content: ["Custom Software Development","Cloud Engineering & DevOps","Product Design (UI/UX)","Data Analytics & AI Integration","IT Consulting & Digital Transformation"] },
        { title: "Why Work With Us?", content: ["Work on cutting-edge technologies","Exposure to global clients and projects","Fast-tracked career growth","Employee-first policies","Open-door leadership approach"] },
        { title: "Roles & Responsibilities", content: ["Develop user-facing features using React.js","Collaborate with backend developers and designers to improve usability","Optimize applications for maximum speed","Maintain high-quality code and reusable components","Ensure technical feasibility of UI/UX designs"] },
        { title: "Required Skills", content: ["Proficiency in HTML, CSS, JavaScript (ES6+)","Hands-on experience with React.js and Redux","Familiarity with REST APIs","Basic understanding of version control (Git)","Good debugging and problem-solving skills"] },
        { title: "Preferred Skills", content: ["Experience with TypeScript","Knowledge of Webpack, Babel","Exposure to UI testing frameworks (Jest, React Testing Library)"] },
        { title: "Educational Qualifications", content: ["Bachelor’s degree in Computer Science, Engineering, or equivalent"] },
        { title: "Salary Range", content: ["INR 6 – 10 LPA (Based on Experience)"] },
        { title: "Interview Process", content: ["Resume Screening","Technical Assessment","Virtual Technical Interview","Final HR Round"] },
      ].map((section, index) => (
        <Card key={index} className="mb-3">
          <CardBody className="p-3 rounded-3" style={{ background: "#F5F6F8" }}>
            <h6 className="text-muted mb-2">{section.title}</h6>
            {Array.isArray(section.content) ? (
              <ul className="mb-0">
                {section.content.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            ) : (
              <p className="mb-0">{section.content}</p>
            )}
          </CardBody>
        </Card>
      ))}

      {/* Download Button */}
      <div className="text-end mt-4">
        <Button  className="px-4 p-2 rounded-4 text-white" style={{background:"#006438"}}>Download JD</Button>
      </div>
    </Container>
  </div> 
  );
};

export default ViewJobPost;
